"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconIdProtection = function IconIdProtection(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16.274 9.198a38 38 0 0 0 6.24-2.926c.62-.358 1.382-.358 1.946-.03a48 48 0 0 0 7.465 2.963 30 30 0 0 0 6.2 1.659 2.14 2.14 0 0 1 1.877 1.783l.012.16.01.607c.097 8.829-1.991 16.222-6.199 22.04-1.877 2.598-4.252 4.484-8.395 7l-.915.55a2 2 0 0 1-1.988.007 24.84 24.84 0 0 1-8.323-7.557l-.29-.41c-4.119-5.902-6.107-13.352-5.9-22.25l.019-.168a2.19 2.19 0 0 1 1.83-1.747 32 32 0 0 0 6.41-1.681m7.24-1.194-.695.397a40 40 0 0 1-5.852 2.673 34 34 0 0 1-6.811 1.784.2.2 0 0 0-.12.067l-.024.038-.009.496c-.094 8.205 1.779 15.024 5.548 20.437l.59.831a22.9 22.9 0 0 0 7.374 6.545l.859-.516c3.933-2.387 6.146-4.143 7.83-6.474 4.035-5.58 6.004-12.754 5.81-21.464l.002.118q-.023-.055-.097-.078l-.738-.124a31.6 31.6 0 0 1-5.907-1.64 49.5 49.5 0 0 1-7.76-3.09",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M24 12.638a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M30 27.638a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v6.258l-2-3.007v-3.251a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3.3l-2 2.906z"
  })));
};

export { IconIdProtection, IconIdProtection as default };
